/**
 * Filter for Client/BU  Name if it is modified
 */
const filter = () => {
    return (clientName, isClientGlobalCopy) => {
        console.log(clientName, isClientGlobalCopy);
        var output = clientName;
        if (!isClientGlobalCopy) {
            return output + " (Modified)";
        }
        else {
            return output;
        }
    };
};
const ɵ0 = filter;
export const ClientOrBuModifiedFilter = {
    name: 'clientorbuModified',
    filter: filter
};
export { ɵ0 };
//# sourceMappingURL=fourdotfive-client-or-bu-modified.filter.js.map